// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompactCallViewHeader__container-c88383 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
  min-height: 72px;
  box-sizing: border-box;
  overflow: hidden;
}

.CompactCallViewHeader__button-eaafce {
  flex: 0 0 auto;
  margin-inline-start: 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/Shared/CompactCallViewHeader/CompactCallViewHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 12px 16px;\n  min-height: 72px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.button {\n  flex: 0 0 auto;\n  margin-inline-start: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CompactCallViewHeader__container-c88383`,
	"button": `CompactCallViewHeader__button-eaafce`
};
module.exports = ___CSS_LOADER_EXPORT___;
